import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from "classnames/bind"

import { FluidImage } from "components/shared/fluid-image/FluidImage"
import styles from './../home-page.module.scss';

const cx = classNames.bind(styles)

export const WebCategory = (props) => {
    const {altText, image, link, title, label} = props

    return (
        <div className={cx(["col-md-4", "animate__animated", "d-none", "d-md-inline-block", "website-category", "animate__fade"],
        )}>
            <NavLink
                to={link}
                title={title}
            >
                <FluidImage altText={altText} image={image} />
            </NavLink>
            <h3>
                <NavLink
                    to={link}
                    title={title}
                >
                    {label}
                </NavLink>
            </h3>
        </div>
    )
}